import hyperquest from 'hyperquest';
import {PassThrough} from 'stream';
import {parse as parseUrl,format as formatUrl} from 'url';

import JobDB from './db';

const protocolTestPattern = /^https?:$/;

const request = function (etcddb, url_suffix, query_parameters) {

}

export default class EtcdJobDB extends JobDB {
  constructor({url}) {
    super();
    const urlParts = parseUrl(url, true);
    if (protocolTestPattern.test(urlParts.protocol) == false) {
      throw new Error(`unknown protocol ${urlParts.protocol}`);
    }
    if (!urlParts.query) {
      urlParts.query = {};
    }
    if (urlParts.pathname.slice(-1) != '/') {
      urlParts.pathname += '/';
    }
    this.url = formatUrl(urlParts); 
  }
  atomicSwap(key, value, version) {
    notImplemented("swap"); 
  }
  delete(key, version, cb) {
    const newParts = parseUrl(this.url);
    newParts.pathname += `${encodeURI(key)}`;
    newParts.query.prevIndex = version;
    hyperquest({
      uri: formatUrl(newParts),
      method: 'DELETE'
    }, (err,res) => {
      if (err) cb(err);
      else if (res.statusCode != 200) {
        const statusErr = new Error(`Got HTTP Status Code: ${res.statusCode}`);
        res.pipe(process.stderr);
        cb(statusErr);
      }
      else cb(null);
    });
  }
  get(key, cb) {
    const newParts = parseUrl(this.url);
    newParts.pathname += `${encodeURI(key)}`;
    hyperquest({
      uri: formatUrl(newParts),
      method: 'GET'
    }, (err,res) => {
      if (err) cb(err, null);
      else if (res.statusCode != 200) {
        const statusErr = new Error(`Got HTTP Status Code: ${res.statusCode}`);
        cb(statusErr, null);
      }
      else {
        const pipe = new PassThrough();
        res.pipe(pipe);
        cb(null, pipe);
      }
    });
  }
  insert(key, value, {ttl}={}) {
    const newParts = parseUrl(this.url);
    newParts.pathname += `${encodeURI(key)}`;
    newParts.query.prevExists = 'false';
    hyperquest({
      uri: newParts,
      method: 'PUT'
    }, (err,res) => {
      if (err) cb(err);
      else if (res.statusCode != 201) {
        const statusErr = new Error(`Got HTTP Status Code: ${res.statusCode}`);
        cb(statusErr);
      }
      else cb(null);
    });
  }
  update(key, value, {ttl}={}) {
    notImplemented("update"); 
  }
  upsert(key, value, {ttl}={}) {
    notImplemented("upsert"); 
  }
  watch(namespace, observer) {
    notImplemented("watch"); 
  }
}
